import Sampler from './sampler';

Sampler.init();

function purgeArray (arr, val) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === val) {
      arr.splice(i, 1);
      i--;
    }
  }

  return arr;
}

export default {
  settings: {
    delay: 0.15
  },

  state: {
    mouseDown: false,
    soundsPlaying: {},
    notesPlaying: []
  },

  startNote (midiNumber, options = {}) {
    const { chorded } = options;

    if (this.state.soundsPlaying[midiNumber]) {
      return;
    }

    let noteAudioContext;

    try {
      noteAudioContext = new AudioContext();
    } catch (exception) {
      return;
    }

    const audioData = Sampler.getCurrentSound();
    const source = noteAudioContext.createBufferSource();

    source.buffer = audioData;

    const gainNode = noteAudioContext.createGain();

    source.connect(gainNode);
    gainNode.connect(noteAudioContext.destination);

    source.playbackRate.value = Sampler.getPitchRatio(midiNumber);

    source.start(0);

    this.state.soundsPlaying[midiNumber] = { noteAudioContext, gainNode };

    this.state.notesPlaying.push(midiNumber);

    document.dispatchEvent(new CustomEvent('noteStart', { detail: { midiNumber, chorded } }));
  },

  stopNote (midiNumber) {
    if (!this.state.soundsPlaying[midiNumber]) {
      return;
    }

    const { noteAudioContext, gainNode } = this.state.soundsPlaying[midiNumber];

    gainNode.gain.linearRampToValueAtTime(0, noteAudioContext.currentTime + 0.05);

    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('noteStop', { detail: { midiNumber } }));

      delete this.state.soundsPlaying[midiNumber];

      purgeArray(this.state.notesPlaying, midiNumber);

      noteAudioContext.close();
    }, 50);
  },

  playChord (chordNotes, steps = false) {
    return new Promise(resolve => {
      const delay = steps ? 200 : 0;

      chordNotes.forEach((midiNumber, i) => {
        const startAt = (i + 1) * delay;
        const duration = 2000;
        const chorded = true;

        setTimeout(() => {
          this.startNote(midiNumber, { duration, chorded });
        }, startAt);

        setTimeout(() => {
          this.stopNote(midiNumber);

          if (i === chordNotes.length - 1) {
            resolve();
          }
        }, startAt + duration);
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/components/piano.js